// Shared by V3ScoresOverview and V3FundamentalScoresAnalysis — maps V2's colorVar values
// onto V3's own bar-tier tokens (see v3-scores-overview/CLAUDE.md).
const V3_SCORE_COLOR_VAR: Record<string, string> = {
  '--fundamental-score-green': '--v3-score-good',
  '--fundamental-score-yellow': '--v3-score-neutral',
  '--fundamental-score-red': '--v3-score-bad',
  '--fundamental-score-grey': '--v3-score-unsure',
};

export function toV3ColorVar(colorVar: string): string {
  return V3_SCORE_COLOR_VAR[colorVar] ?? '--v3-score-unsure';
}
